import type { AxiosInstance } from "axios";
import axios from "axios";
import { getUrlFromEnv } from "./getUrlFromEnv";

export const initApi = (envUrl: string): AxiosInstance => {
  const url = getUrlFromEnv(envUrl);
  return axios.create({ baseURL: url });
};
